import React, { useEffect, useState, Component } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataProvider } from './contexts/DataContext'; // CORREGIDO: Ruta verificada para eliminar el error amarillo
import { NotificationProvider, useNotifications } from './contexts/NotificationContext';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
// --- PARCHE PARA ELIMINAR LOS 500+ ERRORES DE MONACO ---
import { loader } from '@monaco-editor/react';
// Configuramos el cargador de Monaco para que use un CDN externo.
// Esto evita el error "Unexpected usage" al no encontrar los web workers locales.
loader.config({
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.45.0/min/vs'
  }
});
// ------------------------------------------------------
// Módulos de la aplicación
import { Dashboard } from './components/modules/Dashboard';
import { Patients } from './components/modules/Patients';
import { Doctors } from './components/modules/Doctors';
import { Appointments } from './components/modules/Appointments';
import { Services } from './components/modules/Services';
import { Insurance } from './components/modules/Insurance';
import { Specialties } from './components/modules/Specialties';
import { Contacts } from './components/modules/Contacts';
import { Companies } from './components/modules/Companies';
import { Opportunities } from './components/modules/Opportunities';
import { Settings } from './components/modules/Settings';
import { ClinicalHistory } from './components/modules/ClinicalHistory';
import { AuditLog } from './components/modules/AuditLog';
import { FollowUpNotes } from './components/modules/FollowUpNotes';
import { WhatsAppAutomation } from './components/modules/WhatsAppAutomation';
function AppContent() {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  const {
    addNotification
  } = useNotifications();
  const [currentModule, setCurrentModule] = useState('dashboard');
  // Always reset to dashboard when authentication state changes (login/logout)
  useEffect(() => {
    if (isAuthenticated) {
      setCurrentModule('dashboard');
    }
  }, [isAuthenticated]);
  // Hacer addNotification disponible globalmente para otros contextos
  useEffect(() => {
    ;
    (window as any).addNotification = addNotification;
    return () => {
      delete (window as any).addNotification;
    };
  }, [addNotification]);
  // Pantalla de carga inicial
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900" data-id="element-0">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-500" data-id="element-1"></div>
      </div>;
  }
  // Si no está autenticado, mostrar página de Login
  if (!isAuthenticated) {
    return <LoginPage data-id="element-2" />;
  }
  // Sistema de navegación por módulos
  const renderModule = () => {
    switch (currentModule) {
      case 'dashboard':
        return <Dashboard onNavigate={setCurrentModule} data-id="element-3" />;
      case 'patients':
        return <Patients data-id="element-4" />;
      case 'doctors':
        return <Doctors data-id="element-5" />;
      case 'appointments':
        return <Appointments data-id="element-6" />;
      case 'clinical-history':
        return <ClinicalHistory data-id="element-7" />;
      case 'services':
        return <Services data-id="element-8" />;
      case 'insurance':
        return <Insurance data-id="element-9" />;
      case 'specialties':
        return <Specialties data-id="element-10" />;
      case 'contacts':
        return <Contacts data-id="element-11" />;
      case 'companies':
        return <Companies data-id="element-12" />;
      case 'opportunities':
        return <Opportunities data-id="element-13" />;
      case 'follow-up-notes':
        return <FollowUpNotes data-id="element-14" />;
      case 'audit-log':
        return <AuditLog data-id="element-15" />;
      case 'settings':
        return <Settings data-id="element-16" />;
      default:
        return <Dashboard onNavigate={setCurrentModule} data-id="element-17" />;
    }
  };
  return <Layout currentModule={currentModule} onModuleChange={setCurrentModule} data-id="element-18">
      {renderModule()}
    </Layout>;
}
// Componente principal con todos los Providers
export function App() {
  return <ThemeProvider data-id="element-19">
      <AuthProvider data-id="element-20">
        <NotificationProvider data-id="element-21">
          <DataProvider data-id="element-22">
            <AppContent data-id="element-23" />
          </DataProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>;
}